import type { Deal } from "../types";

type EnrollmentState = Pick<Deal, "stage" | "archived_at">;

// Active: the child is (or may soon be) in the class.
export const ACTIVE_ENROLLMENT_STAGES = ["registered", "trial", "waitlist"];
// Past: the enrollment is over.
export const PAST_ENROLLMENT_STAGES = ["lost"];

export const isActiveEnrollment = (deal: EnrollmentState) =>
  !deal.archived_at && ACTIVE_ENROLLMENT_STAGES.includes(deal.stage);

export const isPastEnrollment = (deal: EnrollmentState) =>
  !!deal.archived_at || PAST_ENROLLMENT_STAGES.includes(deal.stage);

/**
 * Splits a family's enrollments into active, in progress (an inquiry not yet
 * decided) and past (lost or archived). Every enrollment lands in one group.
 */
export const splitEnrollments = <T extends EnrollmentState>(deals: T[]) => ({
  active: deals.filter(isActiveEnrollment),
  inProgress: deals.filter(
    (deal) => !isActiveEnrollment(deal) && !isPastEnrollment(deal),
  ),
  past: deals.filter(isPastEnrollment),
});
